import { lazy } from 'react';

export const AdvancedTable = lazy(() => import('./AdvancedTablePage'));
export const Button = lazy(() => import('./ButtonPage'));
export const ButtonGroup = lazy(() => import('./ButtonGroupPage'));
export const Checkbox = lazy(() => import('./CheckboxPage'));
export const ColorPicker = lazy(() => import('./ColorPickerPage'));
export const CollapsibleSearchInput = lazy(() =>
    import('./CollapsibleSearchInputPage')
);
export const Combobox = lazy(() => import('./ComboboxPage'));
export const DateAndTimePicker = lazy(() => import('./DatePickerPage'));
export const Dropdown = lazy(() => import('./DropdownPage'));
export const FilePicker = lazy(() => import('./FilePickerPage'));
export const FormField = lazy(() => import('./FormFieldPage'));
export const Icon = lazy(() => import('./IconPage'));
export const IconButton = lazy(() => import('./IconButtonPage'));
export const InlineInput = lazy(() => import('./InlineInputPage'));
export const Input = lazy(() => import('./InputPage'));
export const InputGroup = lazy(() => import('./InputGroupPage'));
export const Label = lazy(() => import('./LabelPage'));
export const Link = lazy(() => import('./LinkPage'));
export const LoadingSpinner = lazy(() => import('./LoadingSpinnerPage'));
export const LogicEditor = lazy(() => import('./LogicEditorPage'));
export const Menu = lazy(() => import('./MenuPage'));
export const Modal = lazy(() => import('./ModalPage'));
export const Pagination = lazy(() => import('./PaginationPage'));
export const Popover = lazy(() => import('./PopoverPage'));
export const QuickSearch = lazy(() => import('./QuickSearchPage'));
export const Radio = lazy(() => import('./RadioPage'));
export const SearchInput = lazy(() => import('./SearchInputPage'));
export const SelectMenu = lazy(() => import('./SelectMenuPage'));
export const Slider = lazy(() => import('./SliderPage'));
export const NumberStepper = lazy(() => import('./NumberStepperPage'));
export const Switch = lazy(() => import('./SwitchPage'));
export const Tab = lazy(() => import('./TabPage'));
export const Table = lazy(() => import('./TablePage'));
export const Toolbar = lazy(() => import('./ToolbarPage'));
export const Tooltip = lazy(() => import('./TooltipPage'));
export const UIProvider = lazy(() => import('./UIProviderPage'));
export const PortalTargetProvider = lazy(() =>
    import('./PortalTargetProviderPage')
);
